import { useContext, useEffect, useState } from "react";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { AppContext } from "../../../context/AppContext";
import ReportDate from "../../../components/Reports/ReportDate";
import Select from "react-select";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import { Link } from "react-router-dom";
import axios from "axios";
import config from "../../../config/config";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import Reportcurrencysymbols from "../../../common/Reportcurrencysymbols";
import moment from "moment";
import { toastError, toastWarn } from "../../../common/Toast";

const DepositDetailReport = (props) => {
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [responseData, setResponseData] = useState([]);
  const [depositToAccount, setDepositToAccount] = useState([]);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const {
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    currencySymbolLocation,
  } = useContext(AppContext);
  const locationid = localStorage.getItem("Location");
  const token = localStorage.getItem("Token");
  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value === 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };

  const apiCall = () => {
    setLoading(true);
    setResponseData([]);

    axios
      .get(
        `${config.reportsBaseUrl}/reports/depositdetailreport?&startdate=${startdate}&enddate=${enddate}&locationid=${locationid}&distributionaccountid=${selectedAccounts}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          if (res.data.ResponseData?.length > 0) {
            setLoading(false);
          } else {
            toastWarn("No Records Found!");
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        toastError("Something went Wrong");
        setLoading(false);
        return;
      });
  };

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        return res;
      });
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/accountddl?type=3&undepositedfunds=true`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const mappedReceivingItems = res.data.ResponseData.map((item) => {
          const mappedItem = {
            label: item.Name,
            value: item.ID,
          };
          return mappedItem;
        });
        setDepositToAccount(mappedReceivingItems);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const headerMenu = function () {
    const table = this;
    const menu = [];
    const columns = table.getColumns();

    // Check if we have saved visibility state in localStorage
    const savedVisibility = localStorage.getItem("columnVisibility");
    const visibilityState = savedVisibility ? JSON.parse(savedVisibility) : {};

    for (let column of columns) {
      const field = column.getField();
      const columnDef = column.getDefinition();
      const defaultVisible = columnDef.defaultVisible == true; // Default to true if not specified

      console.log(visibilityState, "visibilityState", defaultVisible);

      // Determine initial visibility:
      // 1. Use saved state if available
      // 2. Fall back to defaultVisible if no saved state
      const shouldBeVisible = visibilityState.hasOwnProperty(field)
        ? visibilityState[field]
        : defaultVisible;

      // Set column visibility
      if (shouldBeVisible) {
        column.show();
      } else {
        column.hide();
      }

      // Create menu item with icon
      const icon = document.createElement("i");
      icon.classList.add("fas");
      icon.classList.add(column.isVisible() ? "fa-check-square" : "fa-square");

      const label = document.createElement("span");
      const title = document.createElement("span");
      title.textContent = " " + columnDef.title;
      label.appendChild(icon);
      label.appendChild(title);

      menu.push({
        label: label,
        action: function (e) {
          e.stopPropagation();

          // Toggle visibility
          const newVisibility = !column.isVisible();
          if (newVisibility) {
            column.show();
            icon.classList.remove("fa-square");
            icon.classList.add("fa-check-square");
          } else {
            column.hide();
            icon.classList.remove("fa-check-square");
            icon.classList.add("fa-square");
          }

          // Update and save visibility state
          visibilityState[field] = newVisibility;
          localStorage.setItem(
            "columnVisibility",
            JSON.stringify(visibilityState)
          );
        },
      });
    }

    return menu;
  };

  const columns = [
    {
      title: "Id",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "Id",
      defaultVisible: true,
    },
    {
      title: "Transaction Date",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "TransactionDate",
      defaultVisible: true,
      width: 160,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()}`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Transaction Type",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "TransactionType",
      defaultVisible: true,
      width: 160,
      formatter: function (cell) {
        const value = cell.getValue();

        return `<span style="
          color: #333;
          font-weight: bold;
          text-decoration: underline;
          cursor: pointer;
        ">${value}</span>`;
      },
      cellClick: function (e, cell) {
        const rowData = cell.getRow().getData();
        const Id = rowData.Id;
        const detailURL =
          rowData.TransactionType == "Deposit"
            ? `/bank-deposit/${Id}`
            : `/receive-payment/${Id}`;
        window.open(detailURL, "_blank");
      },
    },
    {
      title: "Num",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "Num",
      defaultVisible: true,
      width: 120,
    },
    {
      title: "Customer Full Name",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "CustomerFullName",
      defaultVisible: true,
      width: 170,
    },
    {
      title: "Memo/Description",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "MemoDescription",
      defaultVisible: true,
      width: 160,
    },
    {
      title: "Cleared",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "Cleared",
      defaultVisible: true,
      width: 120,
    },
    {
      title: "Amount",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "Amount",
      defaultVisible: true,
      width: 130,

      formatter: function (cell) {
        const value = cell.getValue();
        const numericValue =
          value == "0.00" || value === "" || value == null
            ? "0.0"
            : Reportcurrencysymbols(
                Number(value),
                { CurrencySymbol },
                FractionDigits,
                currencySymbolLocation
              );

        return `<span style="
          color: #333;
          font-weight: bold;
          text-decoration: underline;
          cursor: pointer;
        ">${numericValue}</span>`;
      },
      cellClick: function (e, cell) {
        const rowData = cell.getRow().getData();
        const Id = rowData.Id;
        const detailURL =
          rowData.TransactionType == "Deposit"
            ? `/bank-deposit/${Id}`
            : `/receive-payment/${Id}`;
        window.open(detailURL, "_blank");
      },
    },
    {
      title: "Distribution Account",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "DistributionAccount",
      defaultVisible: true,
      width: 160,
    },
    {
      title: "Created By",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "CreatedBy",
      defaultVisible: true,
      width: 160,
    },
    {
      title: "Created On",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "CreatedOn",
      defaultVisible: true,
      width: 160,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Full Name",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "FullName",
      defaultVisible: true,
      width: 160,
    },
    {
      title: "Account Full Name",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "AccountFullName",
      defaultVisible: true,
      width: 160,
    },
    {
      title: "Modified By",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "ModifiedBy",
      defaultVisible: true,
      width: 160,
    },
    {
      title: "Modified On",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "ModifiedOn",
      defaultVisible: true,
      width: 160,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Name",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "Name",
      defaultVisible: true,
      width: 160,
    },
    {
      title: "Payment Method",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "PaymentMethod",
      defaultVisible: true,
      width: 160,
    },
    {
      title: "Distribution Account Type",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "DistributionAccountType",
      defaultVisible: true,
      width: 180,
    },
    {
      title: "Account Type",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "AccountType",
      defaultVisible: true,
      width: 160,
    },
    {
      title: "Vendor",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "Vendor",
      defaultVisible: true,
      width: 150,
    },
  ];

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">Deposit Detail</li>
              </ul>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-5">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-4">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-auto">
              <label className="col-form-label col-md-12">
                Distribution account
              </label>
              <div className="row">
                <div className="col-md-12 z-4">
                  <Select
                    options={depositToAccount}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    isMulti={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    onChange={(selected) =>
                      setSelectedAccounts(selected?.map((e) => e.value) || [])
                    }
                    value={depositToAccount.filter((b) =>
                      selectedAccounts.includes(b.value)
                    )}
                    className="reports-filter-custom-width custom-select-search z-5"
                  />
                </div>
              </div>
            </div>
            <div className="col-auto align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                onClick={() => {
                  apiCall();
                }}
              >
                Run Report
              </button>
            </div>
          </div>
          {responseData.length > 0 && (
            <>
              <div className="card mt-3">
                <div className="card-body">
                  <div className="container">
                    <div className="col-md-12 text-center " id="header">
                      <h6 class="p">SonarPos</h6>
                      <p className="fw-bold p-regular">Deposit Detail</p>
                      <div className="row mb-2">
                        <p>
                          Date:{" "}
                          {startdate === "" && enddate === ""
                            ? "All Data"
                            : moment(startdate).format(
                                `${dateFormate.toUpperCase()}`
                              ) +
                              " - " +
                              moment(enddate).format(
                                `${dateFormate.toUpperCase()}`
                              )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div>
                    <div>
                      <CommonTabular
                        Data={responseData}
                        columns={columns}
                        Groupvalue={["AccountFullName", "Id"]}
                        Reportname={"Deposit Detail"}
                        frozenRowvalue={0}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default DepositDetailReport;
